import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './app';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// Keep the existing descendant routes while enabling navigation blockers.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <Suspense>
        <App />
      </Suspense>
    ),
  },
]);

root.render(
  <HelmetProvider>
    <RouterProvider router={router} />
  </HelmetProvider>
);
